import db from '@/rxdb/database';
import { map } from 'rxjs';
import { getCachedObservable } from '@/rxdb/observablesCache';

function mapDeduction(item) {
    if (item) {
        const plainItem = item.toMutableJSON();
        return {
            ...plainItem,
            emissionDate: plainItem.emissionDate ? new Date(plainItem.emissionDate) : null,
        };
    } else {
        return null;
    }
}

export async function bulkInsert(projectId, deductions) {
    return db.getProjectCollections(projectId).deductions.bulkInsert(deductions);
}
function mapDeductions(dbDeductions) {
    return dbDeductions.map(mapDeduction);
}

export function getDeductions(projectId) {
    return getCachedObservable('getDeductions_' + projectId, () =>
        db
            .getProjectCollections(projectId)
            .deductions.find({ sort: [{ createdAt: 'asc' }] })
            .$.pipe(map((deductions) => mapDeductions(deductions))),
    );
}
export function getDeduction(projectId, deductionId) {
    return db
        .getProjectCollections(projectId)
        .deductions.findOne({ selector: { id: deductionId } })
        .$.pipe(map(mapDeduction));
}

export function removeDeduction(projectId, id) {
    return db
        .getProjectCollections(projectId)
        .deductions.findOne({ selector: { id: id } })
        .remove();
}

export async function createDeduction(projectId, item) {
    const result = await db.getProjectCollections(projectId).deductions.insert({
        projectId,
        deductionStatus: 'definitive',
        ...item,
        emissionDate: item.emissionDate ? item.emissionDate.toISOString() : new Date().toISOString(),
    });
    return result.toJSON();
}

export async function updateDeduction(projectId, deduction) {
    const dbDeduction = await db
        .getProjectCollections(projectId)
        .deductions.findOne({ selector: { id: deduction.id } })
        .exec();
    const patch = { ...JSON.parse(JSON.stringify(deduction)) };
    if (deduction.emissionDate === null || !!deduction.emissionDate) {
        patch.emissionDate = deduction.emissionDate ? deduction.emissionDate.toISOString() : null;
    }
    return dbDeduction.atomicPatch(patch);
}
